import { getPlpListSearch  } from "../api/plp-search.api";
export const gotPlpListDetailEvent = getPlpListSearch.matchFulfilled;